"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var chart_element_1 = require("../chart_element");

var object_1 = require("../object");

var GuideClass =
/*#__PURE__*/
function (_chart_element_1$Char) {
  _inherits(GuideClass, _chart_element_1$Char);

  function GuideClass() {
    var _this;

    _classCallCheck(this, GuideClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GuideClass).apply(this, arguments));
    _this.attributeNames = ["value", "value2"];
    _this.attributes = {
      value: {
        name: "value",
        type: Specification.AttributeType.Number
      },
      value2: {
        name: "value2",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  }

  _createClass(GuideClass, [{
    key: "initializeState",
    value: function initializeState() {
      this.state.attributes.value = 0;
      this.state.attributes.value2 = 0;
    }
  }, {
    key: "getAxis",
    value: function getAxis() {
      return this.object.properties.axis;
    }
  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver) {
      var _solver$attrs = solver.attrs(this.state.attributes, ["value", "value2"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 2),
          value = _solver$attrs2[0],
          value2 = _solver$attrs2[1];

      solver.addLinear(solver_1.ConstraintStrength.HARD, this.object.properties.gap, [[1, value], [-1, value2]]);
    }
    /** Get handles given current state */

  }, {
    key: "getHandles",
    value: function getHandles() {
      var inf = [-1000, 1000];
      var r = [{
        type: "line",
        axis: this.getAxis(),
        actions: [{
          type: "attribute",
          attribute: "value"
        }],
        value: this.state.attributes.value,
        span: inf
      }];

      if (this.object.properties.gap > 0) {
        r.push({
          type: "line",
          axis: this.getAxis(),
          actions: [{
            type: "attribute",
            attribute: "value2"
          }],
          value: this.state.attributes.value2,
          span: inf
        });
      }

      return r;
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var r = [{
        type: this.getAxis(),
        value: this.state.attributes.value,
        attribute: "value",
        visible: true
      }];

      if (this.object.properties.gap > 0) {
        r.push({
          type: this.getAxis(),
          value: this.state.attributes.value2,
          attribute: "value2",
          visible: true
        });
      }

      return r;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Guide"), manager.row("Split Gap", manager.inputNumber({
        property: "gap"
      }, {}))];
    }
  }]);

  return GuideClass;
}(chart_element_1.ChartElementClass);

GuideClass.classID = "guide.guide";
GuideClass.type = "guide";
GuideClass.metadata = {
  displayName: "Guide",
  iconPath: "guide/x"
};
GuideClass.defaultProperties = {
  gap: 0
};
exports.GuideClass = GuideClass;

var GuideCoordinatorClass =
/*#__PURE__*/
function (_chart_element_1$Char2) {
  _inherits(GuideCoordinatorClass, _chart_element_1$Char2);

  function GuideCoordinatorClass() {
    _classCallCheck(this, GuideCoordinatorClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(GuideCoordinatorClass).apply(this, arguments));
  }

  _createClass(GuideCoordinatorClass, [{
    key: "buildConstraints",
    value: function buildConstraints(solver) {
      var attrs = this.state.attributes;
      var t1, t2;

      if (this.getAxis() == "x") {
        t1 = solver.attr(attrs, "x1");
        t2 = solver.attr(attrs, "x2");
      } else {
        t1 = solver.attr(attrs, "y1");
        t2 = solver.attr(attrs, "y2");
      }

      var length = this.object.properties.count;
      this.getValueNames().map(function (name, index) {
        var t = (1 + index) / (length + 1);
        solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1 - t, t1], [t, t2]], [[1, solver.attr(attrs, name)]]);
      });
    }
  }, {
    key: "getValueNames",
    value: function getValueNames() {
      var attrs = [];

      for (var i = 0; i < this.object.properties.count; i++) {
        var name = "value".concat(i);
        attrs.push(name);

        if (this.state) {
          if (this.state.attributes[name] == null) {
            this.state.attributes[name] = 0;
          }
        }
      }

      return attrs;
    }
  }, {
    key: "initializeState",
    value: function initializeState() {
      var v = this.attributeNames;
      this.state.attributes.x1 = -100;
      this.state.attributes.y1 = -100;
      this.state.attributes.x2 = 100;
      this.state.attributes.y2 = 100;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.getValueNames()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var name = _step.value;

          if (this.state.attributes[name] == null) {
            this.state.attributes[name] = 0;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "getAxis",
    value: function getAxis() {
      return this.object.properties.axis;
    }
    /** Get handles given current state */

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var axis = this.getAxis();
      return [{
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: axis == "y" ? x1 : x2,
        y: axis == "x" ? y1 : y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: axis == "y" ? "x1" : "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: axis == "x" ? "y1" : "y2"
        }]
      }];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1;
      var x2 = attrs.x2,
          y2 = attrs.y2;

      if (this.getAxis() == "x") {
        y2 = y1;
      } else {
        x2 = x1;
      }

      return {
        type: "line",
        visible: true,
        morphing: true,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var _this2 = this;

      return this.getValueNames().map(function (name) {
        return {
          type: _this2.getAxis(),
          value: _this2.state.attributes[name],
          attribute: name,
          visible: true
        };
      });
    }
    /** Get controls given current state */

  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Guide Coordinator"), manager.row("Count", manager.inputNumber({
        property: "count"
      }, {
        showUpdown: true,
        updownTick: 1,
        updownRange: [1, 100],
        minimum: 1,
        maximum: 100
      }))];
    }
  }, {
    key: "attributeNames",
    get: function get() {
      return ["x1", "y1", "x2", "y2"].concat(this.getValueNames());
    }
  }, {
    key: "attributes",
    get: function get() {
      var r = {
        x1: {
          name: "x1",
          type: Specification.AttributeType.Number
        },
        y1: {
          name: "y1",
          type: Specification.AttributeType.Number
        },
        x2: {
          name: "x2",
          type: Specification.AttributeType.Number
        },
        y2: {
          name: "y2",
          type: Specification.AttributeType.Number
        }
      };

      for (var i = 0; i < this.object.properties.count; i++) {
        var name = "value".concat(i);
        r[name] = {
          name: name,
          type: Specification.AttributeType.Number
        };
      }

      return r;
    }
  }]);

  return GuideCoordinatorClass;
}(chart_element_1.ChartElementClass);

GuideCoordinatorClass.classID = "guide.guide-coordinator";
GuideCoordinatorClass.type = "guide";
GuideCoordinatorClass.metadata = {
  displayName: "GuideCoordinator",
  iconPath: "guide/coordinator-x"
};
GuideCoordinatorClass.defaultAttributes = {
  axis: "x",
  count: 4
};
exports.GuideCoordinatorClass = GuideCoordinatorClass;

function registerClasses() {
  object_1.ObjectClasses.Register(GuideClass);
  object_1.ObjectClasses.Register(GuideCoordinatorClass);
}

exports.registerClasses = registerClasses;